import React from 'react';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(1),
  },
  link: {
    fontSize: theme.typography.pxToRem(14),
  },
}));

const FacilityDetail = ({
  label,
  content,
  isLink = false,
}: {
  label: string,
  content: string,
  isLink?: boolean,
}) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid item>{label}：</Grid>
      <Grid item>
        {isLink ? (
          <Typography
            component="a"
            href={content}
            rel="noopener"
            className={classes.link}
          >
            {content}
          </Typography>
        ) : (
          content
        )}
      </Grid>
    </Grid>
  );
};

export default FacilityDetail;
